export default __webpack_public_path__ + "static/media/PT-Root-UI_Regular.51b7ac2a.woff2";